import { State } from "./state";

export class WorkflowMetaData {
    public __classname__: string = 'WorkflowMetaData';

    public Deadline : string | null = null;
	public Urgency : string | null = null;
	public Modifier : string | null = null;
	public Modified : string | null = null;
	public Creator : string | null = null;
	public Created : string | null = null;
	public Comment : string | null = null;
	public State : State | null = null;
	public RouteTo : string | null = null;
	public LockedBy : string | null = null;
	public Version : string | null = null;
	public DeadlineSoft : string | null = null;
	public Rating : number | null = null;
	public Deletor : string | null = null;
	public Deleted : string | null = null;

    constructor(
        params : WorkflowMetaDataNamedParameters
    ) {
        this.Deadline = params.Deadline ?? null;
        this.Urgency = params.Urgency ?? null;
        this.Modifier = params.Modifier ?? null;
        this.Modified = params.Modified ?? null;
        this.Creator = params.Creator ?? null;
        this.Created = params.Created ?? null;
        this.Comment = params.Comment ?? null;
        this.State = params.State ?? null;
        this.RouteTo = params.RouteTo ?? null;
        this.LockedBy = params.LockedBy ?? null;
        this.Version = params.Version ?? null;
        this.DeadlineSoft = params.DeadlineSoft ?? null;
        this.Rating = params.Rating ?? null;
        this.Deletor = params.Deletor ?? null;
        this.Deleted = params.Deleted ?? null;
    }
}

export interface WorkflowMetaDataNamedParameters {
    Deadline? : string 
    Urgency? : string 
    Modifier? : string 
    Modified? : string 
    Creator? : string 
    Created? : string 
    Comment? : string 
    State? : State 
    RouteTo? : string 
    LockedBy? : string 
    Version? : string 
    DeadlineSoft? : string 
    Rating? : number 
    Deletor? : string 
    Deleted? : string
}